import React from 'react'
import {NavLink} from "react-router-dom";
import Notifications from "./Notifications";
import { Icon } from '@fluentui/react';
import { connect } from 'react-redux';
import { PermissionRole } from "../../GlobalConst/globalEnums";
import LoggedUser from "./LoggedUser";
import { setNavigation } from '../../actions/appActions';


const administration =
    {
        id : 1,
        urlKey : 'Administration',
        name : "Administration",
        navigation: '/Administration',
        isRestricted: true,
    };

const createAsite =
    {

        id : 2,
        urlKey: 'CreateSite',
        name : "Create Team or Site",
        navigation: '/CreateSite',
        isRestricted: false,
    };

const manageCenter =
    {
        id : 3,
        urlKey: 'ManageCenter',
        name : "Manage Center",
        navigation: '/ManageCenter',
        isRestricted: false,
        isDefault: true
    };

// const testCenter =
//     {
//         id : 4,
//         urlKey: 'TestCenter',
//         name : "Test Center",
//         navigation: '/TestCenter',
//         isRestricted: false,
//     };


export const tableLink = [
   administration,
   createAsite,
   manageCenter,
  //  testCenter
]

class Navigation extends React.Component
{    
    componentDidMount(): void {
        let url = window.location.pathname;
        let array = url.split('/');
        let last = array.slice(-1).pop();
        let res = tableLink.filter(x => last === '' ? x.isDefault : x.urlKey === last);
        last = res.length !== 0 ? res[0].urlKey : "";
        this.props.setNavigation(last);
    }

    isClicked(key)
    {
        return key === this.props.navigation;
    }

    linkClicked(key)
    {
        this.props.setNavigation(key);
    }


    render() {
        const selectedItem = tableLink.filter(x => x.urlKey === this.props.navigation);
        document.title = selectedItem.length ? selectedItem[0].name : "Collaboration";
        const navi = <div className='link-item-box'>
            {tableLink.map(x=> (this.props.isAdmin || !x.isRestricted) &&
                <NavLink key={x.urlKey} to={x.navigation}>
                    <div className={`link-item ${this.isClicked(x.urlKey) && 'link-item-clicked'}`}  onClick={() => this.linkClicked(x.urlKey)}>
                        {x.name}
                    </div>
                </NavLink> )}

                {
                    this.props.role === PermissionRole.administrator &&
                    <NavLink key='Settings' to='/Settings'>
                        <div className={`nav-icon-item ${this.isClicked('Settings') && 'link-item-clicked'}`} onClick={() => this.linkClicked('Settings')}>
                            <Icon iconName="settings" />
                        </div>
                    </NavLink>
                }
                
                <div style={{float:'right'}}>
                    <LoggedUser user={this.props.user}/>
                </div>
            <Notifications/>
        </div>

        return(
            <div>
                <nav className='navigation'>
                    {navi}
                </nav>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    isAdmin: state.user.isAdmin,
    role: state.user.role,
    user: state.user.currentUser,
    isMsTeamsApp: state.app.isMsTeamsApp,
    navigation: state.app.navigation
})

const mapActionToProp = {
    setNavigation
}

export default connect(mapStateToProps, mapActionToProp)(Navigation);



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js